import { useQuery } from '@tanstack/react-query';
import { ICounter } from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';

export const unReviewedCount = async () => {
  let res = await apiManager.get<ICounter>("/admin/driver/unreviewed/count");
  return res;
};

export const useUnreviewedCount = () =>
  useQuery({
    queryKey: ["unreviewed_count"],
    queryFn: async (): Promise<ICounter> => {
      const res = await apiClient.get("/admin/driver/unreviewed/count");
      return res.data;
    },
  });